// Internet Explorer 6-11
export const isIE = /*@cc_on!@*/ false || !!document.documentMode;
